module.exports = __webpack_public_path__ + "img/img36_6.fc8e6dc4.svg";